import { gql } from '@apollo/client'

export const BRAND_EXPLORER = gql`
  query BrandExplorerQuery($input: DateRangeInput!) {
    brandExplorer(input: $input) {
      brandInfo {
        brand {
          name
          id
        }
        numStores
        sovi
        soviPercentChange
      }
    }
  }
`
